export enum REFERENCE_FILTER_COMPARISON_TYPES {
  DIRECT = 'DIRECT',
  OTHER_FIELD = 'OTHER_FIELD',
}

export enum REFERENCE_FILTER_COMPARISON_OPERATORS {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  GREATER_THEN = 'GREATER_THEN',
  GREATER_THEN_OR_EQUAL = 'GREATER_THEN_OR_EQUAL',
  LESS_THEN = 'LESS_THEN',
  LESS_THEN_OR_EQUAL = 'LESS_THEN_OR_EQUAL',
}
